import Image from 'next/image';
import LpImage from '@images/lp-banner-1.jpg';

export const LpLinkBlock: React.FC = () => (
  <div className='py-8 text-center hover:opacity-80'>
    <a href='#contact-form' aria-label='問い合わせフォーム'>
      <Image src={LpImage} alt='希望ぴったりの外注先がラクして見つかる' />
    </a>
  </div>
);
